module.exports = "/assets/data/9785dc678a33ec0d1a9df59712a8b4ee-DN17.data.json";